import i18n from '@/i18n'

export default [
  {
    path: '/billing',
    name: 'billingOverview',
    component: () => import(/* webpackChunkName: "Billing" */ '@/views/Billing.vue'),
    props: (route) => ({ ...route.params }),
    meta: {
      noContextRequired: true,
      permissions: ['Billing.Invoices.Create'],
      menu: {
        index: 80,
        routeName: 'billingOverview',
        activeWhen: ['billingOverview'],
        title: i18n.t('label.billing'),
        icon: ['fal', 'money-check-alt'],
        canShow: ({ context }) => !context.isSelected('business')
      }
    }
  }
]
